export default __webpack_public_path__ + "7c04231a7b1d7a136315cf6adabfbe8a.png";